<ng-template #emailrt let-r="result" let-t="term">
  <div class="item-search-select">
    <span class="item-dest">{{ r.surname }}, {{ r.forename }} {{ r.email }}</span>
  </div>
</ng-template>

<ng-template #companyrt let-r="result" let-t="term">
  <div class="item-search-select">
    <span class="item-dest">{{ r.name }}</span>
  </div>
</ng-template>

<div>
  <div class="flex-row-container align-items-end book-for-container">
    <label i18n="@@invokeUser_label">Book for</label>
    <section (mouseleave)="tt.close()" class="container">
      <button
        type="button"
        class="accessible-tooltip-trigger ico ico-info-circle"
        i18n-ngbTooltip
        ngbTooltip="Use this option to apply the settings of the person you want to book for so that any configuration settings for Travel Policy, Management Information and Products they are permitted to book will apply to the person you are booking for plus any additional Travellers."
        triggers="manual"
        #tt="ngbTooltip"
        (mouseenter)="tt.open()"
        (focus)="tt.open()"
        (blur)="tt.close()"
        (click)="tt.toggle()"
        id="Book_For_Tooltip"
        aria-label="Use this option to apply the settings of the person you want to book for so that any configuration settings for Travel Policy, Management Information and Products they are permitted to book will apply to the person you are booking for plus any additional Travellers."
      >
        <span class="visuallyhidden" id="Book_For_Tooltip_Text"
          >Use this option to apply the settings of the person you want to book for so that any
          configuration settings for Travel Policy, Management Information and Products they are
          permitted to book will apply to the person you are booking for plus any additional
          Travellers.</span
        >
      </button>
    </section>
  </div>
  @if (!invokeuser?.id) {
    <div class="flex-row-container">
      <input
        appInput
        [border]="true"
        [noIcon]="true"
        [ngbTypeahead]="searchTravellers"
        [resultTemplate]="emailrt"
        [(ngModel)]="invokeuser"
        placeholder="Enter the email address of the user you want to book for."
        [inputFormatter]="userFormatter"
        i18n-placeholder
        (click)="$event.currentTarget.select()"
        (ngModelChange)="change()"
        type="text"
      />
    </div>
  }
  <app-invoked-user (reset)="removeBobo()" [searchPage]="true"></app-invoked-user>
</div>
